import { createStore, applyMiddleware } from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import allReducer from './reducer';
import { menuMiddleware } from './menus';

let middlewares = [];

switch (process.env.NODE_ENV) {
  case 'production':
    middlewares = [thunk, menuMiddleware];
    break;
  case 'development':
    middlewares = [thunk, menuMiddleware, logger];
    break;
  default:
    middlewares = [thunk, menuMiddleware];
}

export default createStore(allReducer, applyMiddleware(...middlewares));
